"use strict";
/**
 * 期货表格页面配置
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableqihuoitemconfig = exports.hashqhtable = void 0;
/**
 * hash表格配置
 */
exports.hashqhtable = {
    futures_energy: {
        type: 'block',
        blockname: "energy",
        table: "block_common",
    },
    futures_finance: {
        type: 'block',
        blockname: "financial",
        table: "block_common",
    },
    futures_metal: {
        type: 'block',
        blockname: "metal",
        table: "block_common",
    },
    futures_farmproduce: {
        type: 'block',
        blockname: "agricultural",
        table: "block_common",
    },
    /** 期货-上期所 */
    futures_113: {
        type: 'market',
        code: '113',
        table: "market_common",
    },
    /** 期货子类通配 futures_114_11 */
    futures_num_num: {
        type: 'variety',
        code: '113/1',
        table: "market_common",
    },
    options_type_common: {
        type: 'option',
        code: '151',
        customparams: "variety:7",
        table: "option",
    },
    /** 期货-上期能源 */
    futures_142: {
        type: 'market',
        code: '142',
        table: "market_common",
    },
    /** 期货-大商所 */
    futures_114: {
        type: 'market',
        code: '114',
        table: "market_common",
    },
    /** 期货-郑商所 */
    futures_115: {
        type: 'market',
        code: '115',
        table: "market_common",
    },
    /** 期货-广期所 */
    futures_225: {
        type: 'market',
        code: '225',
        table: "market_common",
    },
    /** 期货-中金所 */
    futures_cffex: {
        type: 'market',
        code: '220',
        table: "market_common",
    },
    "futures_cffex-_ts": {
        type: 'variety',
        code: '220/6',
        table: "market_common",
    },
    "futures_cffex-_tf": {
        type: 'variety',
        code: '220/5',
        table: "market_common",
    },
    "futures_cffex-_t": {
        type: 'variety',
        code: '220/4',
        table: "market_common",
    },
    "futures_cffex-_tl": {
        type: 'variety',
        code: '220/8',
        table: "market_common",
    },
    "futures_cffex-_ih": {
        type: 'variety',
        code: '220/3',
        table: "market_common",
    },
    "futures_cffex-_ic": {
        type: 'variety',
        code: '220/1',
        table: "market_common",
    },
    "futures_cffex-_if": {
        type: 'variety',
        code: '220/2',
        table: "market_common",
    },
    "futures_cffex-_im": {
        type: 'variety',
        code: '220/7',
        table: "market_common",
    },
    /** 期货-港交所 */
    futures_hkex: {
        type: 'market',
        code: 'HKSTOCKF',
        hk_delayfs: 'HKSTOCKFDL',
        show_hk_delay_info: true,
        table: "hkex",
    },
    hk_index_futures: {
        type: 'market',
        code: 'HKINDEXF',
        hk_delayfs: 'HKINDEXFDL',
        show_hk_delay_info: true,
        table: "hkex_nosupport",
    },
    hk_stock_futures: {
        type: 'market',
        code: 'HKSTOCKF',
        hk_delayfs: 'HKSTOCKFDL',
        show_hk_delay_info: true,
        table: "hkex",
    },
    hcf_cus: {
        type: 'market',
        code: 'HKCNYF',
        hk_delayfs: 'HKCNYFDL',
        show_hk_delay_info: true,
        table: "hkex_nosupport",
    },
    hmfs_lrp: {
        type: 'market',
        code: 'HKMETALFS',
        hk_delayfs: 'HKMETALFSDL',
        show_hk_delay_info: true,
        table: "hkex_nosupport",
    },
    /** 期货-国际期货 */
    futures_global: {
        type: 'market',
        code: 'COMEX,NYMEX,COBOT,SGX,NYBOT,LME,MDEX,TOCOM,IPE',
        table: "global",
    },
    "futures_global-cobot": {
        type: 'market',
        code: 'COBOT',
        table: "global",
    },
    "futures_global-nymex": {
        type: 'market',
        code: 'NYMEX',
        table: "global",
    },
    "futures_global-comex": {
        type: 'market',
        code: 'COMEX',
        table: "global",
    },
    "futures_global-nybot": {
        type: 'market',
        code: 'NYBOT',
        table: "global",
    },
    "futures_global-lme": {
        type: 'market',
        code: 'LME',
        table: "global",
    },
    "futures_global-ipe": {
        type: 'market',
        code: 'IPE',
        table: "global",
    },
    "futures_global-tocom": {
        type: 'market',
        code: 'TOCOM',
        table: "global",
    },
    "futures_global-sgx": {
        type: 'market',
        code: 'SGX',
        table: "global",
    },
    "futures_global-mdex": {
        type: 'market',
        code: 'MDEX',
        table: "global",
    },
    options_cffex_all: {
        type: 'option',
        code: '221',
        table: "option",
    },
    options_shfe_all: {
        type: 'option',
        code: '151',
        table: "option",
    },
    options_dce_all: {
        type: 'option',
        code: '140',
        table: "option",
    },
    options_czce_all: {
        type: 'option',
        code: '141',
        table: "option",
    },
    options_ine_all: {
        type: 'option',
        code: '163',
        table: "option",
    },
    options_gfex_all: {
        type: 'option',
        code: '226',
        table: "option",
    },
    options_zjcffex_all: {
        type: 'option',
        code: '221',
        customparams: "variety:1",
        table: "option",
    },
    options_zjcffex_rengou: {
        type: 'option',
        code: '221',
        customparams: "variety:1,cp:c",
        table: "option",
    },
    options_zjcffex_rengu: {
        type: 'option',
        code: '221',
        customparams: "variety:1,cp:p",
        table: "option",
    },
    options_zjcffex_mo_all: {
        type: 'option',
        code: '221',
        customparams: "variety:2",
        table: "option",
    },
    options_zjcffex_mo_rengou: {
        type: 'option',
        code: '221',
        customparams: "variety:2,cp:c",
        table: "option",
    },
    options_zjcffex_mo_rengu: {
        type: 'option',
        code: '221',
        customparams: "variety:2,cp:p",
        table: "option",
    },
    options_zjcffex_ho_all: {
        type: 'option',
        code: '221',
        customparams: "variety:3",
        table: "option",
    },
    options_zjcffex_ho_rengou: {
        type: 'option',
        code: '221',
        customparams: "variety:3,cp:c",
        table: "option",
    },
    options_cu_all: {
        type: 'option',
        code: '151',
        customparams: "variety:1",
        table: "option",
    },
    options_ru_all: {
        type: 'option',
        code: '151',
        customparams: "variety:2",
        table: "option",
    },
    options_au_all: {
        type: 'option',
        code: '151',
        customparams: "variety:3",
        table: "option",
    },
    options_al_all: {
        type: 'option',
        code: '151',
        customparams: "variety:4",
        table: "option",
    },
    options_zn_all: {
        type: 'option',
        code: '151',
        customparams: "variety:5",
        table: "option",
    },
    options_rb_all: {
        type: 'option',
        code: '151',
        customparams: "variety:6",
        table: "option",
    },
    options_ag_all: {
        type: 'option',
        code: '151',
        customparams: "variety:7",
        table: "option",
    },
    options_br_all: {
        type: 'option',
        code: '151',
        customparams: "variety:8",
        table: "option",
    },
    options_pb_all: {
        type: 'option',
        code: '151',
        customparams: "variety:9",
        table: "option",
    },
    options_ni_all: {
        type: 'option',
        code: '151',
        customparams: "variety:10",
        table: "option",
    },
    options_sn_all: {
        type: 'option',
        code: '151',
        customparams: "variety:11",
        table: "option",
    },
    options_ao_all: {
        type: 'option',
        code: '151',
        customparams: "variety:12",
        table: "option",
    },
    options_beanpulp_all: {
        type: 'option',
        code: '140',
        customparams: "variety:1",
        table: "option",
    },
    options_c_all: {
        type: 'option',
        code: '140',
        customparams: "variety:2",
        table: "option",
    },
    options_t_all: {
        type: 'option',
        code: '140',
        customparams: "variety:3",
        table: "option",
    },
    options_lpg_all: {
        type: 'option',
        code: '140',
        customparams: "variety:4",
        table: "option",
    },
    options_pp_all: {
        type: 'option',
        code: '140',
        customparams: "variety:5",
        table: "option",
    },
    options_pvc_all: {
        type: 'option',
        code: '140',
        customparams: "variety:6",
        table: "option",
    },
    options_pe_all: {
        type: 'option',
        code: '140',
        customparams: "variety:7",
        table: "option",
    },
    options_p_all: {
        type: 'option',
        code: '140',
        customparams: "variety:8",
        table: "option",
    },
    options_a_all: {
        type: 'option',
        code: '140',
        customparams: "variety:9",
        table: "option",
    },
    options_b_all: {
        type: 'option',
        code: '140',
        customparams: "variety:10",
        table: "option",
    },
    options_y_all: {
        type: 'option',
        code: '140',
        customparams: "variety:11",
        table: "option",
    },
    options_eg_all: {
        type: 'option',
        code: '140',
        customparams: "variety:12",
        table: "option",
    },
    options_eb_all: {
        type: 'option',
        code: '140',
        customparams: "variety:13",
        table: "option",
    },
    options_jd_all: {
        type: 'option',
        code: '140',
        customparams: "variety:14",
        table: "option",
    },
    options_cs_all: {
        type: 'option',
        code: '140',
        customparams: "variety:15",
        table: "option",
    },
    options_lh_all: {
        type: 'option',
        code: '140',
        customparams: "variety:16",
        table: "option",
    },
    options_lg_all: {
        type: 'option',
        code: '140',
        customparams: "variety:17",
        table: "option",
    },
    options_sugar_all: {
        type: 'option',
        code: '141',
        customparams: "variety:1",
        table: "option",
    },
    options_cf_all: {
        type: 'option',
        code: '141',
        customparams: "variety:2",
        table: "option",
    },
    options_cf_ta: {
        type: 'option',
        code: '141',
        customparams: "variety:4",
        table: "option",
    },
    options_cf_ma: {
        type: 'option',
        code: '141',
        customparams: "variety:3",
        table: "option",
    },
    options_cf_cp: {
        type: 'option',
        code: '141',
        customparams: "variety:5",
        table: "option",
    },
    options_cf_oi: {
        type: 'option',
        code: '141',
        customparams: "variety:7",
        table: "option",
    },
    options_cf_pk: {
        type: 'option',
        code: '141',
        customparams: "variety:8",
        table: "option",
    },
    options_cf_px: {
        type: 'option',
        code: '141',
        customparams: "variety:9",
        table: "option",
    },
    options_cf_sh: {
        type: 'option',
        code: '141',
        customparams: "variety:10",
        table: "option",
    },
    options_cf_sf: {
        type: 'option',
        code: '141',
        customparams: "variety:11",
        table: "option",
    },
    options_cf_sm: {
        type: 'option',
        code: '141',
        customparams: "variety:12",
        table: "option",
    },
    options_cf_ap: {
        type: 'option',
        code: '141',
        customparams: "variety:13",
        table: "option",
    },
    options_cf_ur: {
        type: 'option',
        code: '141',
        customparams: "variety:14",
        table: "option",
    },
    options_cf_sa: {
        type: 'option',
        code: '141',
        customparams: "variety:15",
        table: "option",
    },
    options_cf_pf: {
        type: 'option',
        code: '141',
        customparams: "variety:16",
        table: "option",
    },
    options_cf_fg: {
        type: 'option',
        code: '141',
        customparams: "variety:17",
        table: "option",
    },
    options_cf_cj: {
        type: 'option',
        code: '141',
        customparams: "variety:18",
        table: "option",
    },
    options_ine_sc: {
        type: 'option',
        code: '163',
        table: "option",
    },
    options_gfex_si: {
        type: 'option',
        code: '226',
        customparams: "variety:1",
        table: "option",
    },
    options_gfex_lc: {
        type: 'option',
        code: '226',
        customparams: "variety:2",
        table: "option",
    },
    options_gfex_ps: {
        type: 'option',
        code: '226',
        customparams: "variety:3",
        table: "option",
    },
    options_uscny_all: {
        type: 'market',
        code: 'HKUSDCNHOP',
        hk_delayfs: 'HKUSDCNHOPDL',
        show_hk_delay_info: true,
        table: "option",
    },
    options_zjcffex_ho_rengu: {
        type: 'option',
        code: '221',
        customparams: "variety:3,cp:p",
        table: "option",
    },
    options_zjcffex_txbj: {
        type: 'option',
        code: '221/1',
        table: "option_txbj",
    },
    options_zjcffex_mo_txbj: {
        type: 'option',
        code: '221/2',
        table: "option_txbj",
    },
    options_zjcffex_ho_txbj: {
        type: 'option',
        code: '221/3',
        table: "option_txbj",
    }
};
/**
 * 表格字段配置
 */
exports.tableqihuoitemconfig = {
    block_common: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
            sort_default: true,
            sort_direct: 'desc',
        },
        {
            title: "今开",
            type: "quote",
            value: "今开价",
            sort: true,
        },
        {
            title: "最高",
            type: "quote",
            value: "最高价",
            sort: true,
        },
        {
            title: "最低",
            type: "quote",
            value: "最低价",
            sort: true,
        },
        {
            title: "昨结",
            type: "quote",
            value: "昨结",
            sort: true,
        },
        {
            title: "成交量",
            type: "quote",
            value: "成交量",
            sort: true,
        },
        {
            title: "买盘(外盘)",
            type: "quote",
            value: "外盘_买盘",
            sort: true,
            sort_alias: "BuyOrder"
        },
        {
            title: "卖盘(内盘)",
            type: "quote",
            value: "内盘_卖盘",
            sort: true,
            sort_alias: "SellOrder"
        },
        {
            title: "持仓量",
            type: "quote",
            value: "持仓量",
            sort: true,
        },
    ],
    market_common: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
            sort_alias: "Code"
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
            sort_alias: "Name"
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
            sort_alias: "Close"
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
            sort_alias: "Change"
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
            sort_default: true,
            sort_direct: 'desc',
            sort_alias: "ChangePercent"
        },
        {
            title: "今开",
            type: "quote",
            value: "今开价",
            sort: true,
            sort_alias: "Open"
        },
        {
            title: "最高",
            type: "quote",
            value: "最高价",
            sort: true,
            sort_alias: "High"
        },
        {
            title: "最低",
            type: "quote",
            value: "最低价",
            sort: true,
            sort_alias: "Low"
        },
        {
            title: "昨结",
            type: "quote",
            value: "昨结",
            sort: true,
            sort_alias: "PreviousSettlement"
        },
        {
            title: "成交量",
            type: "quote",
            value: "成交量",
            sort: true,
            sort_alias: "Volume"
        },
        {
            title: "成交额",
            type: "quote",
            value: "成交额",
            sort: true,
            sort_alias: "Amount"
        },
        {
            title: "买盘(外盘)",
            type: "quote",
            value: "外盘_买盘",
            sort: true,
            sort_alias: "BuyOrder"
        },
        {
            title: "卖盘(内盘)",
            type: "quote",
            value: "内盘_卖盘",
            sort: true,
            sort_alias: "SellOrder"
        },
        {
            title: "持仓量",
            type: "quote",
            value: "持仓量",
            sort: true,
            sort_alias: "OpenInterest"
        },
    ],
    hkex: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
            sort_default: true,
            sort_direct: 'asc',
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "买入价",
            type: "quote",
            value: "买入价",
            sort: true,
        },
        {
            title: "卖出价",
            type: "quote",
            value: "卖出价",
            sort: true,
        },
        {
            title: "买量",
            type: "quote",
            value: "买入量",
            sort: true,
        },
        {
            title: "卖量",
            type: "quote",
            value: "卖出量",
            sort: true,
        },
        {
            title: "总量",
            type: "quote",
            value: "成交量",
            sort: true,
        },
        {
            title: "现量",
            type: "quote",
            value: "现量",
            sort: true,
        },
        {
            title: "持仓量",
            type: "quote",
            value: "持仓量",
            sort: true,
        },
        {
            title: "日增",
            type: "quote",
            value: "日增",
            sort: true,
        },
        {
            title: "昨结算",
            type: "quote",
            value: "昨结",
            sort: true,
        },
    ],
    hkex_nosupport: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "名称",
            sort: true,
            sort_default: true,
            sort_direct: 'asc',
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "买入价",
            type: "quote",
            value: "买入价",
            sort: true,
        },
        {
            title: "卖出价",
            type: "quote",
            value: "卖出价",
            sort: true,
        },
        {
            title: "买量",
            type: "quote",
            value: "买入量",
            sort: true,
        },
        {
            title: "卖量",
            type: "quote",
            value: "卖出量",
            sort: true,
        },
        {
            title: "总量",
            type: "quote",
            value: "成交量",
            sort: true,
        },
        {
            title: "现量",
            type: "quote",
            value: "现量",
            sort: true,
        },
        {
            title: "持仓量",
            type: "quote",
            value: "持仓量",
            sort: true,
        },
        {
            title: "日增",
            type: "quote",
            value: "日增",
            sort: true,
        },
        {
            title: "昨结算",
            type: "quote",
            value: "昨结",
            sort: true,
        },
    ],
    global: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
            sort_default: true,
            sort_direct: 'desc',
        },
        {
            title: "今开",
            type: "quote",
            value: "今开价",
            sort: true,
        },
        {
            title: "最高",
            type: "quote",
            value: "最高价",
            sort: true,
        },
        {
            title: "最低",
            type: "quote",
            value: "最低价",
            sort: true,
        },
        {
            title: "昨结",
            type: "quote",
            value: "昨结",
            sort: true,
        },
        {
            title: "成交量",
            type: "quote",
            value: "成交量",
            sort: true,
        },
        {
            title: "买盘(外盘)",
            type: "quote",
            value: "外盘_买盘",
            sort: true,
            sort_alias: "BuyOrder"
        },
        {
            title: "卖盘(内盘)",
            type: "quote",
            value: "内盘_卖盘",
            sort: true,
            sort_alias: "SellOrder"
        },
        {
            title: "持仓量",
            type: "quote",
            value: "持仓量",
            sort: true,
        },
    ],
    option: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
            sort_default: true,
            sort_direct: 'desc',
        },
        {
            title: "成交量",
            type: "quote",
            value: "成交量",
            sort: true,
        },
        {
            title: "成交额",
            type: "quote",
            value: "成交额",
            sort: true,
        },
        {
            title: "持仓量",
            type: "quote",
            value: "持仓量",
            sort: true,
        },
        {
            title: "行权价",
            type: "quote",
            value: "期权行权价",
            sort: true,
        },
        {
            title: "剩余日",
            type: "quote",
            value: "期权剩余期限",
            sort: true,
        },
        {
            title: "日增",
            type: "quote",
            value: "日增",
            sort: true,
        },
        {
            title: "昨结",
            type: "quote",
            value: "昨结",
            sort: true,
        },
        {
            title: "今开",
            type: "quote",
            value: "今开价",
            sort: true,
        }
    ],
    option_txbj: [
        {
            title: "名称",
            type: "quote",
            sort: false,
            tip: "<span class='icon_qa_tit' title='非标准合约第一次调整，行权价增加标识A；第二次调整，行权价增加标识B'></span>"
        },
        {
            title: "最新",
            type: "quote",
            value: "最新价",
            sort: true,
            sortby: "c,p",
        },
        {
            title: "涨跌幅",
            type: "quote",
            sort: true,
            sortby: "c,zdf",
        },
        {
            title: "涨跌额",
            type: "quote",
            sort: true,
            sortby: "c,zde",
        },
        {
            title: "持仓量",
            type: "quote",
            sort: true,
            sortby: "c,ccl",
        },
        {
            title: "成交量",
            type: "quote",
            sort: true,
            sortby: "c,vol",
        },
        {
            title: "隐含波动率",
            type: "quote",
            sort: true,
            tip: "<span class='icon_qa_tit' title='隐含波动率(Implied Volatility)是将市场上的期权或权证交易价格代入权证理论价格模型<Black-Scholes模型>，反推出来的波动率数值'></span>",
            sortby: "c,yhbdl",
        },
        {
            title: "折溢价率",
            type: "quote",
            sort: true,
            sortby: "c,zyjl",
            tip: "<span class='icon_qa_tit' title='期权到期前，标的物价格需要变动多少百分比才可让期权投资者在到期日实现损益平衡。溢价率衡量期权风险高低，该值越高，实现损益平衡越不容易，投资风险越高'></span>"
        },
        {
            title: "行权价",
            type: "quote",
            sort: true,
            sortby: "c,xqj",
            sort_default: true,
            sort_direct: 'asc',
            tdclass: "xq_orange",
            tip: "<span class='icon_qa_tit' title='T型报价的行权价以同一行权价格为中心，左侧为认购期权的相关行情，右侧为认沽期权相关行情'></span>"
        },
        {
            title: "名称",
            type: "quote",
            sort: false,
            tip: "<span class='icon_qa_tit' title='非标准合约第一次调整，行权价增加标识A；第二次调整，行权价增加标识B'></span>"
        },
        {
            title: "最新",
            type: "quote",
            sort: true,
            sortby: "p,p",
        },
        {
            title: "涨跌幅",
            type: "quote",
            sort: true,
            sortby: "p,zdf",
        },
        {
            title: "涨跌额",
            type: "quote",
            sort: true,
            sortby: "p,zde",
        },
        {
            title: "持仓量",
            type: "quote",
            sort: true,
            sortby: "p,ccl",
        },
        {
            title: "成交量",
            type: "quote",
            sort: true,
            sortby: "p,vol",
        },
        {
            title: "隐含波动率",
            type: "quote",
            sort: true,
            sortby: "p,yhbdl",
            tip: "<span class='icon_qa_tit' title='隐含波动率(Implied Volatility)是将市场上的期权或权证交易价格代入权证理论价格模型<Black-Scholes模型>，反推出来的波动率数值'></span>"
        },
        {
            title: "折溢价率",
            type: "quote",
            sort: true,
            sortby: "p,zyjl",
            tip: "<span class='icon_qa_tit' title='期权到期前，标的物价格需要变动多少百分比才可让期权投资者在到期日实现损益平衡。溢价率衡量期权风险高低，该值越高，实现损益平衡越不容易，投资风险越高'></span>"
        }
    ]
};
